<swal #error title="Erro" text="" icon="error" [showCancelButton]="false"></swal>